
var invokeCallback = function( callback, args ){
    return this[callback](args);
}

var _doAjax = function(route,packet,withHeaders){

    if( withHeaders !== false ){

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

    }

    $.ajax({
        url:        route,
        type:       typeof packet._method == 'undefined' ? 'POST' : packet._method,
        cache:      false,
        dataType:   'json',
        data:       packet,
        success:    function(returned){
            msg = returned.action.message;
            if( returned.outcome=='FAIL'){
                invokeCallback( msg.callback, msg.with );
                if(typeof returned.action.route !== "undefined"){
                    setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                }
            }
            if( returned.outcome=='PASS'){
                if(msg.callback.length){
                    invokeCallback( msg.callback, msg.with );
                }
                if(typeof returned.action.route !== 'undefined'){
                    setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                }
            }
        },
        error: function(data){
            returned = data.responseJSON;
            var content;
            $.each( returned.errors, function( key, value ) {
                $('#error-'+key).html('<span class="form-text text-danger"><i class="icon-cancel-circle2 mr-2"></i>'+value[0]+'</span>');
                content = value[0];
            });
            alert( content );
        }
    });
}